import React,{ useState,}from 'react'
import { message,Form,Input,Button,Upload,Modal } from 'antd';
import {  useGwGoodsGuigeAddMutation,} from '../../store/ReactWebSiteApi';
import { UploadOutlined,PlusOutlined } from '@ant-design/icons';
function WebGoodsSpecAdd(props) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();   
    //上传图片
    const handleChange = (e) => {
        if (e.file.status === 'done'||e.file.status==='removed') {
            const fileArr = e.fileList.map((item) => {
                const { response } = item
                return response.Result
            })
            // console.log(e);
            let fileStr = fileArr + "";  
            if(fileStr === null){
                fileStr = ''
            }
            setInfo(prevState=>({...prevState,eowgg_image:fileStr,}))
        }
    }
    const [info,setInfo] = useState({
        eowgg_name:'',
        eowgg_image:'',
    });
    const [submitAdd] = useGwGoodsGuigeAddMutation()    
    return (
        <>
            <a onClick={() => {setOpen(true)}}><PlusOutlined /> 新增规格</a>
            <Modal
                open={open}
                title='新增规格'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    submitAdd({
                        "eowgg_eowg_id" : props.eowg_id,
                        "eowgg_eowg_name" : props.eowg_name,
                        "eowgg_image" : info.eowgg_image,
                        "eowgg_jiage" : info.eowgg_jiage,
                        "eowgg_name" : info.eowgg_name,
                        "eowgg_uid" : localStorage.getItem('eu_id'),
                        "eowgg_uname" : localStorage.getItem('eu_name'),
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('新增成功！')  
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    })
                    setOpen(false);
                }}
                
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span:6 }}
                >                           
                    <Form.Item name="name" label='规格名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,eowgg_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="price" label='规格价格' wrapperCol={{span:10}}>
                        <Input
                            onChange={(e) => {setInfo(prevState=>({...prevState,eowgg_jiage:e.target.value}))}}
                        />                       
                    </Form.Item>
                    <Form.Item label="规格图片"                         
                        valuePropName='fileList'
                        getValueFromEvent={e => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            return e && e.fileList;
                        }}
                    >
                        <Upload
                            name="image_file"
                            action="/api/ReactApi/zd_single_upload_image"
                            listType="picture"
                            className="upload-list-inline"
                            onChange={handleChange}
                            >
                            <Button icon={<UploadOutlined />}>点击上传</Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default WebGoodsSpecAdd